import {
  AuthSessionState,
  ImpersonationState,
  SsoState,
} from './auth-state.model';

export const INITIAL_SSO_STATE: SsoState = {
  isCheckingEmail: false,
  isExchangingCode: false,
  email: '',
  oidcConfig: null,
  error: null,
};

export const INITIAL_SESSION_STATE: AuthSessionState = {
  loading: false,
  error: null,
  user: null,
  failedLoginAttempts: 0,
  rememberMe: false,
};

export const INITIAL_IMPERSONATION_STATE: ImpersonationState = {
  status: 'disconnected',
  impersonatedBuyer: null,
  error: null,
};
